import React, {useEffect, useState} from 'react';
import {Spinner} from "../../components";
import Dashboard from "../../layouts/dashboard";
// import DashboardCard from "../../components/dasboard/dashboardCard";
import {Slang} from "../../helpers";
import LangSwitcher from "../../components/langSwitcher";

const Languages = () => {
    const [loadPage, setLoadPage] = useState(true);
    const [spinColor, setSpinColor] = useState("success");

    useEffect(() => {

        let tim2 = setTimeout(() => {
            setLoadPage(false);
        }, 100);

        return () => {
            clearInterval(tim2);
        };
    }, []);

    return (
        <>
            {
                loadPage ? (
                    <>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100vh",
                                width: "100%",
                                position: "fixed",
                                left: 0,
                                top: 0,
                            }}
                        >
                            <Spinner color={spinColor} size={3} />
                        </div>
                    </>
                ) : (
                    <Main />
                )
            }
        </>
    )
};

export default Languages;

const Main = () => {
    // const dCard1Lang = Slang("dashboardNavbar.DashboardCard1");
    // const svgDir = "../../assets/vendor/duotone-icons";
    return (
        <Dashboard>
            <div className="row">
               <div className="col-md-4">
                   <p className="h2">Changer de langue</p>
                   <LangSwitcher sub/>
               </div>
            </div>
        </Dashboard>
    )
}